import { Link, styled } from '@mui/material'

export const StyledInvestmentAccountButton = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderStyle: 'solid',
  borderRadius: theme.spacing(1),
  borderColor: theme.palette.primary.main,
  borderWidth: 1,
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  gap: theme.spacing(1),
  ...theme.typography.text14Regular,
  color: theme.palette.primary.main,
  '&:hover': {
    textDecoration: 'underline',
  },
}))
